export default {
    ultimasMensagens: [],
    templates_campanha: [],
    agendamentos: [],
    ultimosAgendamentos: [],
    mensagens_erro: []
}



// WEBPACK FOOTER //
// ./src/store/modules/mensagens/state.js